import { useQuery, useMutation } from "@tanstack/react-query";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import http_payroll from "AppQuries/utils/http_payroll";

const stagingPayroll = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.PayrollStagingHeaderDetailSave,
    input,
  );
  return data;
};

export const useStagingPayrollMutation = () => {
  return useMutation({
    mutationFn: stagingPayroll,
  });
};

const getStagingPayrollList = async ({
  companyCode,
  locationCode,
  month,
  year,
}) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.PayrollStagingList}?companyCode=${companyCode}&Month=${month}&Year=${year}&LocationCode=${locationCode}`,
  );
  return data;
};

export const useGetPayrollStagingListQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.PayrollStagingList],
    queryFn: () => getStagingPayrollList(input),
    refetchOnWindowFocus: false,
  });
};

const getStagingPayrollDetail = async ({
  companyCode,
  employeeCode = 0,
  locationCode,
  refNo,
}) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.PayrollStagingDetails}?companyCode=${companyCode}&Employeecode=${employeeCode}&Refno=${refNo}&LocationCode=${locationCode}`,
  );
  return data;
};

export const useGetPayrollStagingDetailQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.PayrollStagingDetails],
    queryFn: () => getStagingPayrollDetail(input),
    refetchOnWindowFocus: false,
  });
};

const reCalculatePayrollStage = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.GetStagingPayrollDetails,
    input,
  );
  return data;
};

export const useRecalculatePayrollStageMutation = () => {
  return useMutation({
    mutationFn: reCalculatePayrollStage,
  });
};

const updatePayrollStage = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.PayrollStagingHeaderDetailUpdate,
    input,
  );
  return data;
};

export const useUpdatePayrollStageMutation = () => {
  return useMutation({
    mutationFn: updatePayrollStage,
  });
};

const reCalculateSalary = async (payload) => {
  if (
    payload?.companyCode &&
    payload?.locationCode &&
    payload?.month !== "" &&
    payload?.year !== "" &&
    payload?.userCode &&
    payload?.salaryType &&
    payload?.employeeCode &&
    payload?.basicSalary
  ) {
    const { data } = await http_payroll.post(
      Api_EndPoints.SalaryUpdateReGenerate,
      payload,
    );
    return data;
  }
};

export const useReCalculateSalaryMutation = () => {
  return useMutation({
    mutationFn: reCalculateSalary,
  });
};

const updatePaymentDate = async (payload) => {
  if (
    payload?.companyCode &&
    payload?.paymentDate &&
    Array.isArray(payload?.refNo)
  ) {
    const { data } = await http_payroll.put(
      Api_EndPoints.UpdatePaymentDate,
      payload,
    );
    return data;
  }
};

export const useUpdatePaymentDateMutation = () => {
  return useMutation({
    mutationFn: updatePaymentDate,
  });
};

export const useUpdatePayrollStagingDetailMutation = () => {
  return useMutation({
    mutationFn: reCalculateSalary,
  });
};
